import React from 'react';
import ReactDOM from 'react-dom';
import 'carbon-components/css/carbon-components.min.css';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import WorldMapTable from './components/WorldMapTable';
import widgetDefinition from './WorldMapTable.widget';
import configuration from './data/index';
import { RenderFn } from 'src/types/widgets';

const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale) {
    return;
  }

  ReactDOM.render(
    <IntlProvider locale={locale} messages={messages}>
      <WorldMapTable configuration={configuration} />
    </IntlProvider>,
    element,
    () => cb(element),
  );
};

export default render;
